export const sliceFileName = (fileName: string) => {
    const indexFrom = fileName?.indexOf('_');
    return indexFrom === -1 ? fileName : fileName?.slice(indexFrom + 1, fileName.length);
};

export const sliceStringWithLastCharacter = (currentString: string, character: string) => {
    const lastIndex = currentString?.lastIndexOf(character);
    return lastIndex === -1 ? currentString : currentString?.slice(0, lastIndex);
};
